import { render, staticRenderFns } from "./SearchResultGrid.vue?vue&type=template&id=2b111e05"
import script from "./SearchResultGrid.vue?vue&type=script&lang=js"
export * from "./SearchResultGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports